import { render, staticRenderFns } from "./OrderActivitiesViewDialog.vue?vue&type=template&id=285bf076"
import script from "./OrderActivitiesViewDialog.vue?vue&type=script&lang=js"
export * from "./OrderActivitiesViewDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderActivitiesViewDialog.vue?vue&type=style&index=0&id=285bf076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports